import Extend from 'flarum/common/extenders';
import ArticlePage from './components/ArticlePage';
export default [new Extend.Routes().add('article', '/article/:id', ArticlePage)];